import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { ScenarioField } from "../types/field";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/data-input/field`;

export interface DeleteFieldRequest {
  field: ScenarioField;
  scenarioId: string;
}

export interface DeleteFieldResponse {
  fields: ScenarioField[];
}

const deleteField = async (request: DeleteFieldRequest): Promise<DeleteFieldResponse> => {
  const response = await axios.delete<DeleteFieldResponse>(API_URL, {
    data: {
      field: request.field,
      scenarioId: request.scenarioId
    }
  });

  return response.data;
};

export const useDeleteField = () => {
  const queryClient = useQueryClient();
  return useMutation<DeleteFieldResponse, AxiosError, DeleteFieldRequest>(deleteField, {
    onSuccess: () => {
      queryClient.invalidateQueries(["scenarioFields"]);
    }
  });
};
